<template>
  <header v-if="$route.name !== 'chat'">
    <div>
      <div v-if="$route.name === 'home'" class="left-img img-container">
        <img src="../assets/images/LogoLife_3x.png" />
      </div>
      <!-- <div v-if="$route.name === 'home'" class="header-span">The way Life should be!</div> -->
      <div class="left" v-if="showBackButton">
        <img v-on:tap="backButtonClicked()" src="../assets/rds-life-fonticons/arrow_back.svg" alt />
      </div>
      <!-- icona documentazione-->
      <div
        v-if="isDocumentationButtonVisible"
        v-on:tap="documentationButtonClicked()"
        class="left notifica-bell"
      >
        <IconDocumentation />
      </div>
    </div>
    <div class="center">
      <h2 v-if="$route.name !== 'home'">{{ routeTitle }}</h2>
    </div>
    <div class="right-area">
      <div v-if="isPlusButtonVisible" v-on:tap="plusButtonClicked()" class="right right-text">
        <div class="plus">
          <img src="../assets/images/life_add.svg" />
        </div>
      </div>
      <!-- icona nuova segnalazione-->
      <div v-if="isReportButtonVisible" v-on:tap="reportButtonClicked()" class="right">
        <IconSegnalazione />
      </div>
      <div v-if="isBellButtonVisible" v-on:tap="bellButtonClicked()" class="right">
        <IconBell />
      </div>
      <div v-if="$route.name === 'home'" v-on:tap="dottedButtonClicked()" class="right" style="padding-top: 7px;">
        <i v-on:tap="dottedButtonClicked()" class="rds-icon rds-icon-morewhite rds-icon-dotted"></i>
      </div>
      <div
        class="right right-img"
        v-if="!!userPhoto && isProfileIconVisibile"
        v-bind:class="userPhotoClass"
      >
        <img
          v-on:tap="goTo('/profile')"
          v-bind:class="{ 'visibility-hidden': !isProfileIconVisibile }"
          v-bind:src="userImage"
        />
      </div>
      <div v-if="isConfirmButtonVisible" v-on:tap="confirmButtonClicked()" class="right">
        <IconConfirm />
      </div>
    </div>
  </header>
</template>

<script>
// @ is an alias to /src
// import userService from '../services/User.service';
import config from '../config';
import IconBell from '../assets/rds-life-fonticons/notifiche_v1.svg?inline';
import IconDocumentation from '../assets/images/header/Icona_regolamento.svg?inline';
import IconSegnalazione from '../assets/images/header/icona_segnalazione.svg?inline';
import IconConfirm from '../assets/images/check.svg?inline';
import gapiWrapper from '../services/Cookies.service';
import { eventBus } from '../services/EventBus';
// const user = userService.user;
export default {
  name: 'rds-header',
  components: { IconBell, IconDocumentation, IconSegnalazione, IconConfirm },
  data() {
    return {
      isGoBackVisible: false,
      isPlusButtonVisible: false,
      isBellButtonVisible: false,
      isDocumentationButtonVisible: false,
      isReportButtonVisible: false,
      isConfirmButtonVisible: false,
      userImage: null
    };
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
    },
    goTo(route) {
      console.log(route);
      this.$router.push(route);
    },
    backButtonClicked() {
      if (this.isGoBackVisible) {
        eventBus.$emit('backButtonClicked');
      } else {
        this.goBack();
      }
    },
    plusButtonClicked() {
      eventBus.$emit('plusButtonClicked');
    },
    bellButtonClicked() {
      eventBus.$emit('hideNavettaReport');
      eventBus.$emit('toggleNotifications');
    },
    documentationButtonClicked() {
      const regolamento = config.regolamenti.find(
        r => r.route === this.$route.name
      );
      // window.open(regolamento.url, '_blank');
      downloadURI(regolamento.url);
      // eventBus.$emit('documentationButtonClicked');
    },
    reportButtonClicked() {
      eventBus.$emit('hideNotifications');
      eventBus.$emit('toggleNavettaReport');
    },
    dottedButtonClicked() {
      console.log('toogleMenuProfile');
      eventBus.$emit('toogleMenuProfile');
    },
    confirmButtonClicked() {
      eventBus.$emit('confirmButtonClicked');
    }
  },
  computed: {
    userPhoto() {
      const DEFAULT_IMG =
        'https://rds-life-dev-templates.s3-eu-west-1.amazonaws.com/usersImg/default-user.jpg';
      if (this.userImage !== DEFAULT_IMG) {
        return this.userImage;
      } else {
        return require('../assets/images/placeholder_img_profilo.svg');
      }
    },
    userPhotoClass() {
      let cssClass = '';
      console.log(
        'googleusercontent',
        this.userPhoto.indexOf('googleusercontent') !== -1
      );
      console.log(
        'placeholder_img_profilo',
        this.userPhoto.indexOf('placeholder_img_profilo') !== -1
      );
      if (
        this.userPhoto.indexOf('googleusercontent') !== -1 ||
        this.userPhoto.indexOf('placeholder_img_profilo') !== -1
      ) {
        cssClass = 'google';
      }
      return cssClass;
    },
    isProfileIconVisibile() {
      const toExclude = [
        'home',
        'login',
        'navetta',
        'beauty',
        'bike',
        'barbecue',
        'palestra',
        'editImage',
        'profile',
        'market',
        'mensa'
      ];
      return toExclude.indexOf(this.$route.name) === -1;
    },
    routeTitle: function() {
      return this.$route.meta.title;
    },
    showBackButton() {
      if (!gapiWrapper.androidLogin) {
        if (this.$route.name === 'home' || this.$route.name === 'login') {
          return false;
        } else {
          return true;
        }
      }
      if (this.$route.name === 'home') {
        return false;
      }
      return this.isGoBackVisible;
    }
  },
  created() {
    const vm = this;
    document.addEventListener(
      'deviceready',
      () => {
        document.addEventListener('backbutton', vm.backButtonClicked, false);
      },
      false
    );

    eventBus.$on('showBackButton', () => {
      this.isGoBackVisible = true;
    });
    eventBus.$on('hideBackButton', () => {
      this.isGoBackVisible = false;
    });
    eventBus.$on('showDocumentationButton', () => {
      this.isDocumentationButtonVisible = true;
    });
    eventBus.$on('hideDocumentationButton', () => {
      this.isDocumentationButtonVisible = false;
    });
    eventBus.$on('showBellButton', () => {
      this.isBellButtonVisible = true;
    });
    eventBus.$on('hideBellButton', () => {
      this.isBellButtonVisible = false;
    });
    eventBus.$on('showReportButton', () => {
      this.isReportButtonVisible = true;
    });
    eventBus.$on('hideReportButton', () => {
      this.isReportButtonVisible = false;
    });
    eventBus.$on('showPlusButton', () => {
      this.isPlusButtonVisible = true;
    });
    eventBus.$on('hidePlusButton', () => {
      this.isPlusButtonVisible = false;
    });

    eventBus.$on('showConfirmButton', () => {
      this.isConfirmButtonVisible = true;
    });
    eventBus.$on('hideConfirmButton', () => {
      this.isConfirmButtonVisible = false;
    });

    eventBus.$on('userUpdated', user => {
      console.log('userupdated');
      try {
        this.userImage = user.photos[0];
      } catch (error) {
        console.warn(error);
      }
    });
  }
};
function downloadURI(uri) {
  if (window.cordova) {
    window.cordova.InAppBrowser.open(uri, '_blank');
  } else {
    let link = document.createElement('a');
    link.download = 'document';
    link.href = uri;
    link.click();
  }
}
</script>
<style lang="scss" scoped>
header {
  position: relative;
  display: flex;
  padding: 0 20px 0;
  align-items: center;
  background-color: #ffffff;
  min-height: 62px;
  max-height: 62px;
  z-index: 3;
  .header-span {
    width: 180px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    font-size: 0.85em;
    font-style: italic;
    margin-bottom: 3px;
  }
  & > div {
    display: flex;
    flex-basis: 100%;
    flex: 1;
    &.right-area {
      justify-content: flex-end;
    }
  }
  .left {
    display: flex;
    width: 24px;
  }
  .left-img {
    width: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .left + .left,
  .right + .right {
    margin-left: 21px;
  }
  h2 {
    font-size: 1.1em;
    text-align: center;
    font-weight: 600;
  }
  .center {
    flex-grow: 1;
    display: flex;
    max-width: 60px;
    h2 {
      position: absolute;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      margin: 0;
    }
  }
  .right {
    display: flex;
    &.google.right-img {
      img {
        border-radius: 50%;
        width: 100%;
        position: inherit;
      }
    }
    &.right-img {
      width: 38px;
      margin-left: 21px;
      max-width: none;
      overflow: hidden;
      border-radius: 50%;
      display: flex;
      img {
        height: 38px;
        max-width: none;
        position: relative;
        right: 50%;
        padding: 0;
        margin: 0;
      }
    }
    &.right-text {
      .plus {
        display: flex;
      }
    }
    & ~ & {
      margin-left: 10px;
    }
  }

  img,
  svg {
    padding: 20px;
    margin: -20px;
    // border-radius: 50%;
  }
  .rds-icon-dotted{
    font-size: 0.3em;
    color: #0c3887;
  }
}
</style>
